var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"app-hamburger",class:[_vm.toggled && 'app-hamburger-toggled'],on:{"click":_vm.onToggle}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"app-hamburger-container"},[_c('span',{staticClass:"app-hamburger-line"}),_c('span',{staticClass:"app-hamburger-line"}),_c('span',{staticClass:"app-hamburger-line"})])
}]

export { render, staticRenderFns }